import React from "react";

const OTPModal = ({
    open,
    email,
    otp,
    setOtp,
    error,
    loading,
    onClose,
    onVerify,
    onResend,
    verifyText = "Verify & Register"
}) => {
    if (!open) return null;

    return (
        <div className="otp-overlay">
            <div className="otp-card">

                <button
                    className="otp-close-btn"
                    onClick={onClose}
                    aria-label="Close"
                >
                    ✕
                </button>

                <div className="otp-header">
                    <h2>Email Verification</h2>
                    <p>
                        We’ve sent a 6-digit OTP to <br />
                        <strong>{email}</strong>
                    </p>
                </div>

                <input
                    type="text"
                    maxLength="6"
                    className="otp-input"
                    placeholder="••••••"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                />

                {error && <div className="otp-error">{error}</div>}

                <button
                    className="otp-primary-btn"
                    onClick={onVerify}
                    disabled={loading}
                >
                    {loading ? "Verifying..." : verifyText}
                </button>

                <button
                    className="otp-link-btn"
                    onClick={onResend}
                    disabled={loading}
                >
                    Resend OTP
                </button>

            </div>
        </div>
    );
};

export default OTPModal;
